import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Footer from './footer';
import Header from './header';
import apiUrl from './base_url';
import logo from './img/erwatodaylogo.png';
import ReactHtmlParser from 'react-html-parser';
import { Modal, Button, Form, Spinner } from 'react-bootstrap';

import '../components/cssfile/question_paper.css';

const Question_paper = () => {
  const [questionPapers, setQuestionPapers] = useState([]);
  const [successfulPayments, setSuccessfulPayments] = useState({});
  
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const [searchTerm, setSearchTerm] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [mobileError, setMobileError] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);

  /*
   * ================================
   * LOAD QUESTION PAPERS
   * ================================
   */
  useEffect(() => {
    axios
      .get(apiUrl + 'serverside/question_paper.php')
      .then(response => {
        setQuestionPapers(response.data);
      })
      .catch(error => {
        console.error(
          'Error fetching question papers:',
          error
        );
      });

    /*
     * Load Razorpay
     */
    if (!window.Razorpay) {
      const script = document.createElement('script');

      script.src =
        'https://checkout.razorpay.com/v1/checkout.js';

      script.async = true;

      document.body.appendChild(script);
    }
  }, []);

  /*
   * ================================
   * DESCRIPTION TOGGLE
   * ================================
   */
  const toggleDescription = index => {
    setQuestionPapers(prev => {
      const updated = [...prev];

      updated[index] = {
        ...updated[index],
        isExpanded: !updated[index].isExpanded
      };

      return updated;
    });
  };

  /*
   * ================================
   * OPEN PAYMENT MODAL
   * ================================
   */
  const handlePayment = item => {
    setSelectedItem(item);
    setMobileNumber('');
    setMobileError('');
    setIsProcessing(false);
    setShowModal(true);
  };

  /*
   * ================================
   * CLOSE PAYMENT MODAL
   * ================================
   */
  const handleCloseModal = () => {
    if (isProcessing) {
      return;
    }

    setShowModal(false);
    setSelectedItem(null);
    setMobileNumber('');
    setMobileError('');
    setIsProcessing(false);
  };

  /*
   * ================================
   * MOBILE NUMBER CHANGE
   * ================================
   */
  const handleMobileChange = event => {
    const value = event.target.value.replace(/\D/g, '');

    if (value.length <= 10) {
      setMobileNumber(value);
      setMobileError('');
    }
  };

  /*
   * ================================
   * VALIDATE MOBILE
   * ================================
   */
  const validateMobileNumber = () => {
    if (!mobileNumber) {
      setMobileError(
        'Please enter your mobile number.'
      );

      return false;
    }

    if (!/^[6-9]\d{9}$/.test(mobileNumber)) {
      setMobileError(
        'Please enter a valid 10-digit Indian mobile number.'
      );

      return false;
    }

    setMobileError('');
    return true;
  };

  /*
   * ================================
   * SAVE PAYMENT
   * ================================
   */
  const savePaymentToDatabase = (
    phone,
    paymentId,
    amount,
    questionPaperId
  ) => {
    return axios.post(
      apiUrl + 'serverside/question_paper_pay.php',
      {
        phone,
        payment_id: paymentId,
        amount,
        question_paper_id: questionPaperId
      }
    );
  };

  /*
   * ================================
   * PAYMENT SUCCESS
   * ================================
   */
  const handlePaymentSuccess = response => {
    if (!selectedItem) {
      return;
    }

    const paymentId =
      response.razorpay_payment_id;

    const amount = selectedItem.amount;

    const questionPaperId =
      selectedItem.id;

    const phone = mobileNumber;

    savePaymentToDatabase(
      phone,
      paymentId,
      amount,
      questionPaperId
    )
      .then(databaseResponse => {
        console.log(
          'Payment saved:',
          databaseResponse.data
        );

        setSuccessfulPayments(prev => ({
          ...prev,
          [questionPaperId]: true
        }));

        setIsProcessing(false);
        setShowModal(false);

        alert(
          `Payment successful.\nTransaction ID: ${paymentId}`
        );
      })
      .catch(error => {
        console.error(
          'Error saving payment:',
          error
        );

        setIsProcessing(false);

        alert(
          'Payment was successful, but we could not save the payment record. Please contact support.'
        );
      });
  };

  /*
   * ================================
   * START RAZORPAY
   * ================================
   */
  const handlePaymentProcess = () => {
    if (!selectedItem) {
      return;
    }

    if (!validateMobileNumber()) {
      return;
    }

    if (!window.Razorpay) {
      alert(
        'Payment system is still loading. Please try again.'
      );

      return;
    }

    setIsProcessing(true);

    const options = {
      key: 'rzp_live_AQkJ7i0IS8F2nj',

      amount:
        Number(selectedItem.amount) * 100,

      currency: 'INR',

      name: 'ErwaToday',

      description:
        `Purchase for ${selectedItem.topic_name}`,

      image: logo,

      handler: handlePaymentSuccess,

      prefill: {
        contact: mobileNumber,

        email:
          localStorage.getItem('email') || ''
      },

      notes: {
        question_paper_id:
          selectedItem.id
      },

      theme: {
        color: '#2563eb'
      },

      modal: {
        ondismiss: () => {
          setIsProcessing(false);
        }
      }
    };

    try {
      const razorpay =
        new window.Razorpay(options);

      razorpay.on(
        'payment.failed',
        response => {
          console.error(
            'Payment failed:',
            response
          );

          setIsProcessing(false);

          alert(
            'Payment failed. Please try again.'
          );
        }
      );

      razorpay.open();
    } catch (error) {
      console.error(
        'Razorpay error:',
        error
      );

      setIsProcessing(false);

      alert(
        'Unable to open payment gateway. Please try again.'
      );
    }
  };

  /*
   * ================================
   * SEARCH
   * ================================
   */
  const filteredPapers =
    questionPapers.filter(item =>
      String(item.topic_name || '')
        .toLowerCase()
        .includes(
          searchTerm.toLowerCase()
        )
    );

  /*
   * ================================
   * RENDER
   * ================================
   */
  return (
    <div className="question-paper-page">

      <Header />

      {/* ================================
          PAGE HEADER
      ================================= */}
      <section className="qp-page-header">
        <div className="container">

          <div className="qp-header-content">

            <div>
              <span className="qp-eyebrow">
                ERWATODAY
              </span>

              <h1>
                Question Papers
              </h1>

              <p>
                Practice with previous question
                papers and prepare with confidence.
              </p>
            </div>

          </div>

        </div>
      </section>


      {/* ================================
          MAIN CONTENT
      ================================= */}
      <main className="container qp-main">

        {/* Search */}
        <div className="qp-search-wrapper">

          <div className="qp-search-box">

            <span className="qp-search-icon">
              🔍
            </span>

            <Form.Control
              type="text"
              placeholder="Search question papers..."
              value={searchTerm}
              onChange={e =>
                setSearchTerm(e.target.value)
              }
              className="qp-search-input"
            />

            {searchTerm && (
              <button
                type="button"
                className="qp-search-clear"
                onClick={() =>
                  setSearchTerm('')
                }
              >
                ×
              </button>
            )}

          </div>

          <span className="qp-result-count">
            {filteredPapers.length}{' '}
            {filteredPapers.length === 1
              ? 'paper'
              : 'papers'}
          </span>

        </div>


        {/* ================================
            PAPERS
        ================================= */}
        {filteredPapers.length > 0 ? (

          <div className="row qp-grid">

            {filteredPapers.map(
              (item, index) => (

                <div
                  key={item.id || index}
                  className="
                    col-xl-3
                    col-lg-4
                    col-md-6
                    col-sm-6
                    mb-4
                  "
                >

                  <article className="qp-card">

                    {/* Image */}
                    <div className="qp-card-image">

                      {item.image ? (
                        <img
                          src={item.image}
                          alt={item.topic_name}
                        />
                      ) : (
                        <div className="qp-image-placeholder">
                          📄
                        </div>
                      )}

                      <span
                        className={
                          item.status === 'prime'
                            ? 'qp-status prime'
                            : 'qp-status free'
                        }
                      >
                        {item.status === 'prime'
                          ? 'Premium'
                          : 'Free'}
                      </span>

                    </div>


                    {/* Content */}
                    <div className="qp-card-body">

                      <h3 className="qp-card-title">
                        {item.topic_name}
                      </h3>


                      {/* Description */}
                      <div className="qp-description">

                        {ReactHtmlParser(
                          item.isExpanded
                            ? item.des
                            : String(
                                item.des || ''
                              ).length > 100
                              ? String(
                                  item.des
                                ).slice(
                                  0,
                                  100
                                ) + '...'
                              : item.des
                        )}

                      </div>


                      {String(
                        item.des || ''
                      ).length > 100 && (

                        <button
                          type="button"
                          className="qp-view-more"
                          onClick={() =>
                            toggleDescription(
                              index
                            )
                          }
                        >
                          {item.isExpanded
                            ? 'Show Less'
                            : 'View More'}
                        </button>

                      )}


                      {/* Premium */}
                      {item.status ===
                        'prime' && (

                        <div className="qp-card-footer">

                          <div className="qp-price">
                            <span>
                              Price
                            </span>

                            <strong>
                              ₹
                              {item.amount}
                            </strong>
                          </div>


                          {successfulPayments[
                            item.id
                          ] ? (

                            <a
                              href={item.file}
                              download
                              className="
                                qp-action-button
                                qp-download-button
                              "
                            >
                              ↓ Download Now
                            </a>

                          ) : (

                            <button
                              type="button"
                              className="
                                qp-action-button
                                qp-buy-button
                              "
                              onClick={() =>
                                handlePayment(
                                  item
                                )
                              }
                            >
                              Buy Now
                              <span>
                                →
                              </span>
                            </button>

                          )}

                        </div>

                      )}


                      {/* Free */}
                      {item.status ===
                        'nonprime' && (

                        <a
                          href={item.file}
                          download
                          className="
                            qp-action-button
                            qp-free-download
                          "
                        >
                          Download Now
                          <span>
                            ↓
                          </span>
                        </a>

                      )}

                    </div>

                  </article>

                </div>

              )
            )}

          </div>

        ) : (

          /* Empty */
          <div className="qp-empty">

            <div className="qp-empty-icon">
              🔎
            </div>

            <h3>
              No Question Papers Found
            </h3>

            <p>
              Try searching with another
              keyword.
            </p>

            {searchTerm && (

              <button
                type="button"
                className="qp-empty-button"
                onClick={() =>
                  setSearchTerm('')
                }
              >
                Clear Search
              </button>

            )}

          </div>

        )}

      </main>


      {/* ================================
          PAYMENT MODAL
      ================================= */}
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        centered
        backdrop="static"
        className="qp-payment-modal"
      >

        <Modal.Header closeButton>
          <div className="qp-modal-heading">

            <span className="qp-modal-icon">
              ₹
            </span>

            <div>
              <Modal.Title>
                Complete Payment
              </Modal.Title>

              <small>
                Secure payment powered by
                Razorpay
              </small>
            </div>

          </div>
        </Modal.Header>


        <Modal.Body>

          {selectedItem && (

            <div className="qp-payment-content">

              {/* Product */}
              <div className="qp-payment-product">

                <div className="qp-payment-image">

                  <img
                    src={
                      selectedItem.image
                    }
                    alt={
                      selectedItem.topic_name
                    }
                  />

                </div>

                <div>
                  <span>
                    Question Paper
                  </span>

                  <h4>
                    {
                      selectedItem.topic_name
                    }
                  </h4>
                </div>

              </div>


              {/* Amount */}
              <div className="qp-payment-summary">

                <span>
                  Total Amount
                </span>

                <strong>
                  ₹{selectedItem.amount}
                </strong>

              </div>


              {/* Mobile */}
              <Form.Group className="qp-mobile-field">

                <Form.Label>
                  Mobile Number
                </Form.Label>

                <Form.Control
                  type="tel"
                  inputMode="numeric"
                  maxLength="10"
                  value={
                    mobileNumber
                  }
                  onChange={
                    handleMobileChange
                  }
                  placeholder="Enter your 10-digit mobile number"
                  isInvalid={
                    !!mobileError
                  }
                  disabled={
                    isProcessing
                  }
                />

                <Form.Control.Feedback
                  type="invalid"
                >
                  {mobileError}
                </Form.Control.Feedback>

                <small>
                  This number will be used
                  for your payment record.
                </small>

              </Form.Group>


              {/* Security */}
              <div className="qp-security-note">

                <span>
                  🔒
                </span>

                <div>
                  <strong>
                    Secure Payment
                  </strong>

                  <p>
                    Your payment is securely
                    processed through Razorpay.
                  </p>
                </div>

              </div>

            </div>

          )}

        </Modal.Body>


        <Modal.Footer>

          <Button
            variant="light"
            onClick={handleCloseModal}
            disabled={isProcessing}
            className="qp-cancel-button"
          >
            Cancel
          </Button>

          <Button
            variant="primary"
            onClick={
              handlePaymentProcess
            }
            disabled={isProcessing}
            className="qp-pay-button"
          >

            {isProcessing ? (
              <>
                <Spinner
                  animation="border"
                  size="sm"
                  className="me-2"
                />

                Processing...
              </>
            ) : (
              <>
                Proceed to Pay
                <span className="ms-2">
                  →
                </span>
              </>
            )}

          </Button>

        </Modal.Footer>

      </Modal>


      <Footer />

    </div>
  );
};

export default Question_paper;